import React from 'react';
import PropTypes from 'prop-types';

export const MicHubLayout = ({ children }) => {
  return (<div id="mic__hub__layout">{children}</div>)
};

MicHubLayout.propTypes = {
  children: PropTypes.any
}